<template>
    <div class="col-md-9">
        <div class="pages__title-holder mb-3">
            <h1 class="pages__title m-0">Clients</h1>
            <div class="d-flex align-items-center">
                <a href="/admin/panel/landing-clients/create" class="btn btn_golden mr-1"><span>+ Add New</span></a>
            </div>
        </div>
        <div class="pages__table">
            <div class="pages__top">
                <div class="image">
                    Logo
                </div>
                <div class="route">
                   url
                </div>
                <div class="action">
                    Action
                </div>
            </div>
            <ul class="pages__list">
                <li
                    class="pages__line"
                    v-for="(client, index) in clients"
                    :key="client.id"
                >
                    <div class="image">
                        <img :src="getNameOfAvatar(client.logo)" alt="photo">
                    </div>

                    <div class="route">
                        {{ client.url}}
                    </div>
                    <div class="action">
                        <div class="action__hold">
                            <a
                                :href="`/admin/panel/landing-clients/${client.id}/edit`"
                                class="edit"
                            >
                                <svg width="16" height="16" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-edit"></use>
                                </svg>
                            </a>
                            <a
                                href="javascript:void(0)"
                                class="delete"
                                @click="openDeleteModal(client.id)"
                            >
                                <svg width="16" height="16" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-close-9"></use>
                                </svg>
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <ActionModal
            :modal-id="getCustomModalId('delete',currentClientId)"
            @confirm="deleteClient(currentClientId)"
            :reject-text="`No`"
            :confirm-text="`Yes`"
        >
            <template #body>
                <div class="text-center mb-4">
                    <div class="text-center">
                        <h5 class="title">Are you sure ?</h5>
                        <p>Do you want to delete this client?</p>
                    </div>
                </div>
            </template>
        </ActionModal>
    </div>
</template>

<script>

import ActionModal from "../../Common/ActionModal.vue";
import BaseButtons from "../../Common/BaseButtons.vue";
import ModalHandler from "../../../mixins/ModalHandler";
import AdminPanelService from "../../../services/AdminPanelService";
import ImageGallery from "../../Common/ImageGallery.vue";

export default {
    name: "Clients",
    components: {ImageGallery, BaseButtons, ActionModal},
    mixins: [ModalHandler],
    data() {
        return {
            clients: [],
            currentClientId: null,
        }
    },
    methods: {
        openDeleteModal(id) {
            this.currentClientId = id
            this.$nextTick(()=> {
                this.showCustomModal('delete', id)
            })
        },
        async getListOfClients() {
            try {
                const { data: response } = await AdminPanelService.fetchListOfClients()
                this.clients = response
            } catch (error) {
                console.log(error)
            }
        },
        getNameOfAvatar(photo) {
            return photo ? `/uploads/${photo}` : "/img/svg/avatar.svg";
        },
        async deleteClient(clientId) {
            try {
                await AdminPanelService.deleteClient(clientId)
                this.clients = this.clients.filter(item => item.id !== clientId)
                this.$showSuccessMessage('The client was deleted!')
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The client was not deleted. Please try again')
            }
        }
    },

    mounted() {
        this.getListOfClients()
    }

}

</script>

<style scoped>

</style>
